export default function ScrollToTop ({ ...props })
{
	function scrollToTop()
	{
		window.scroll({ top: 0, behavior: "smooth" });
	}

	return (
		<button type="button"
			onClick={ scrollToTop }
			className='scroll-to-top'
	>
			<span data-icon="arrow-right" className='scroll-to-top--icon' />
		</button>
	);
}